import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects, Collections} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "constants/UserRoles";
import {Button} from "reactstrap";
import Tickets from "../../../../../components/Collections/Tickets";

const breadcrumbsStatic = [{
	name: 'Customers',
	url: '/customers',
	icon: 'users',
}];

export default class Customer extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');


		this.loadLocations = this.loadLocations.bind(this);
		const hash = props.history?.location?.hash || '';
		const initialTab = (hash === '#sales' || hash.startsWith('#sales?')) ? 'av-center' : undefined;
		this.state = {
			...this.state,
			name: '',
			...(initialTab ? {tab: initialTab} : {}),
		}
		this.state.locations = [];
	}

	componentDidMount() {
		const hash = this.props.history?.location?.hash || '';
		if (hash === '#sales') {
			this.props.history.replace({
				...this.props.history.location,
				hash: '#av-center',
			});
			this.setState({tab: 'av-center'});
		}
	}

	loadLocations(contacts) {
		if (contacts) {
			this.setState({
				locations: contacts.locations,
			});
		}
	}

	handleData = (data) => {
		this.setState({name: data.name});
	}

	refreshPage = () => {
		this.setState({
			locations: [],
			key: Math.random(),
			refresh: !this.state.refresh
		});
	};

	render() {
		let {match, history, baseUrl, roles} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				// TODO, check where state is set in View, then can update this on state state change
				name,
				url: `/customers/${match.params.id}`,
				icon: 'users',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}>
					<Button data-id="add-user" onClick={this.toggle('modalAddressAdd')} size="sm" color="primary">
						<i className="fa fa-user"/>&nbsp;&nbsp;Add Address
					</Button>
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Address"}
					object={Objects.CustomerLocation}
					history={this.props.history}
					toggle={this.state.modalAddressAdd}
					reportClose={this.reportClose('modalAddressAdd')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					customer={match.params.id}
					parent={match.params.id}
					reloadPage={this.refreshPage}
				/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Customer" value="details" data-cy={"customer-tab"}/>
					<Tab label="Contact" value="contact" data-cy={'contact-tab'}/>
					<Tab label="Change Log" value="logs"/>
					<Tab label="Address Change Log" value="address-logs"/>
					<Tab label="Tickets" value="tickets"/>
					<Tab label="AV Center" value="av-center"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
					<Objects.Customer
						key={this.state.key}
						id={match.params.id}
						history={history}
						onData={this.handleData}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						loadLocations={this.loadLocations}
						baseUrl={baseUrl}
						goBack={true}
						noDelete={roles.includes(UserRoles.Admin)}
						dataIdSave={"customer-save"}
						dataIdDelete={"customer-delete"}
						fromRoute={true}
						roles={this.props.roles}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'contact'})}>
					<div className={'row'}>
						{this.state.locations.map((location, i) =>
							<div className={'col-6'}>
								<Objects.CustomerLocation
									key={i}
									id={location.pkey}
									parent={match.params.id}
									history={history}
									location={location}
									afterSave={this.refreshPage}
									afterDelete={this.refreshPage}
									//reloadPage={this.refreshPage}
									//reloadSelf={this.state.refresh}
									goBack={true}
									dataIdSave={`address-${i}-save`}
									dataIdDelete={`address-${i}-delete`}
									noDelete={!(roles.length === 1 && roles[0] === 40)}
									display={true}
								/>
							</div>
						)}
					</div>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'logs'})}>
					<Collections.LogsCustomer
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'address-logs'})}>
					<Collections.LogsCustomersLocations
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'tickets'})}>
					<Tickets
						noHeader={true}
						parent={this.props.match.params.id}
						customerFilter={true}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						tickets={this.state.tickets}
						roles={this.props.roles}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'av-center'})}>
					<Collections.CustomerAvCenter
						noHeader={true}
						parent={this.props.match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						roles={this.props.roles}
					/>
				</div>
			</div>
		)
	}
}
